<template>
    <project-step-container
            prev-to="rapid_experiments_with_customers_14"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0">
                {{getMessage(15, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide" :text="getMessage(15, 'rapidexperiment-guide')"/>
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {Steps} from "@/modules/D4D/Utils";

    export default {
        name: "RapidExperimentsWithCustomers15",
        components: { ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_TYPES_OF_EXPERIMENTS,
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.TYPES_EXPERIMENTS)
            }
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index

                Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'rapid_experiments_with_customers_16', params: {index}})
            }
        },
    }
</script>

